// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getRemoteConfig } from "firebase/remote-config";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Create service instances
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 43200000; // 12 hours default

// Connect to emulators if in development mode or running on localhost (for Playwright tests)
const shouldUseEmulators =
  import.meta.env.DEV ||
  (typeof window !== "undefined" && window.location.hostname === "localhost");

if (shouldUseEmulators) {
  // Only connect if not already connected (to avoid multiple connection errors)
  try {
    // Check if auth emulator is already connected by checking the config
    const authConfig = (auth as any)._delegate?._config;
    if (!authConfig?.emulator) {
      connectAuthEmulator(auth, "http://localhost:9099", {
        disableWarnings: true,
      });
      console.log("Connected to Auth emulator");
    }
  } catch (e) {
    // Already connected or error connecting
    const errorMsg = e instanceof Error ? e.message : String(e);
    if (!errorMsg.includes("already been initialized")) {
      console.log("Auth emulator connection:", errorMsg);
    }
  }

  try {
    // Check if Firestore emulator is already connected
    const dbSettings = (db as any)._delegate?._settings;
    if (!dbSettings?.host?.includes("localhost")) {
      connectFirestoreEmulator(db, "localhost", 9095);
      console.log("Connected to Firestore emulator");
    }
  } catch (e) {
    // Already connected or error connecting
    const errorMsg = e instanceof Error ? e.message : String(e);
    if (!errorMsg.includes("already been initialized")) {
      console.log("Firestore emulator connection:", errorMsg);
    }
  }

  try {
    // Check if Storage emulator is already connected
    const storageHost = (storage as any)._delegate?._host;
    if (!storageHost?.includes("localhost")) {
      connectStorageEmulator(storage, "localhost", 9199);
      console.log("Connected to Storage emulator");
    }
  } catch (e) {
    // Already connected or error connecting
    const errorMsg = e instanceof Error ? e.message : String(e);
    if (!errorMsg.includes("already been initialized")) {
      console.log("Storage emulator connection:", errorMsg);
    }
  }
} else {
  console.log(
    "NOT connecting to Firebase emulators. Using live Firebase services."
  );
}

console.log("Firebase initialized");
// console.log("window.location.hostname:", window.location.hostname); // Already logged above or implicitly by emulator connection

// Only initialize analytics in production and in the browser
const shouldInitAnalytics =
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.protocol !== "file:";
let analytics;
if (shouldInitAnalytics) {
  try {
    analytics = getAnalytics(app);
  } catch {
    analytics = undefined;
  }
} else {
  analytics = undefined;
}

export { db, analytics, auth, app, storage, remoteConfig };
